import { Mark } from '@tiptap/core'

const Alignment = Mark.create({
  name: 'alignment',

  addOptions () {
    return {
      textAlign: ['left', 'center', 'right']
    }
  },

  addAttributes () {
    return {
      textAlign: {
        default: 'left',
        parseHTML: element => {
          return element.style.textAlign || element.getAttribute('data-text-align') || 'left'
        },
        renderHTML: attrs => {
          return {
            style: `text-align:${attrs.textAlign}`
          }
        }
      }
    }
  },

  parseHTML () {
    return this.options.textAlign.map(align => ({
      tag: `div[style="text-align:${align}"]`,
      attrs: { textAlign: align }
    }))
  },

  renderHTML ({ HTMLAttributes }) {
    return ['div', HTMLAttributes, 0]
  },

  addCommands () {
    return {
      alignment: attrs => ({ commands }) => {
        return commands.setMark(this.name, attrs)
      }
    }
  }
})

export default Alignment